export const appConfig: IAppConfig = {
  production: {
    website: "https://dataships.io",
    webHost: "https://web-app.dataships.io",
    controlPanelHost: "https://control-panel.dataships.io",
    coreApiHost: "https://core-api.dataships.io",
    adminPanelHost: "https://admin.dataships.io",
    gtmId: "GTM-TK2FB22",
    flagsmithId: "Bajv6H4etYqeFPS5z92jjm",
    flagsmithHost: "https://edge.api.flagsmith.com/api/v1/",
    shopifyAppInstallUrl: "https://apps.shopify.com/dataships",
    complyPDFPolicyUrl: "images.dataships.io",
    hubsportPortalId: "8868359",
    hubsportFormId: "04b6b5d9-8254-4aa4-93ac-7ebf2f3ba137",
    env: "production",
  },
  production_beta: {
    website: "https://dataships.io",
    webHost: "https://web-app-beta.dataships.io",
    controlPanelHost: "https://control-panel-beta.dataships.io",
    coreApiHost: "https://core-api-beta.dataships.io",
    adminPanelHost: "https://admin-beta.dataships.io",
    gtmId: "GTM-TK2FB22",
    flagsmithId: "Bajv6H4etYqeFPS5z92jjm",
    flagsmithHost: "https://edge.api.flagsmith.com/api/v1/",
    shopifyAppInstallUrl: "https://apps.shopify.com/dataships",
    complyPDFPolicyUrl: "images.dataships.io",
    hubsportPortalId: "8868359",
    hubsportFormId: "04b6b5d9-8254-4aa4-93ac-7ebf2f3ba137",
    env: "production",
  },
  staging: {
    website: "https://wordpress.dataships.tools",
    webHost: "https://web-app.dataships.eu",
    controlPanelHost: "https://control-panel.dataships.eu",
    coreApiHost: "https://core-api.dataships.eu",
    adminPanelHost: "https://admin.dataships.eu",
    gtmId: "GTM-TGPTPKZ",
    flagsmithId: "Hy3fX5HrL9gXMdqqrKeBxX",
    flagsmithHost: "https://edge.api.flagsmith.com/api/v1/",
    shopifyAppInstallUrl:
      "https://partners.shopify.com/2404667/apps/13700890625/overview",
    complyPDFPolicyUrl: "images.dataships.eu",
    hubsportPortalId: "8868359",
    hubsportFormId: "04b6b5d9-8254-4aa4-93ac-7ebf2f3ba137",
    env: "staging",
  },
  staging_beta: {
    website: "https://wordpress.dataships.tools",
    webHost: "https://web-app-beta.dataships.eu",
    controlPanelHost: "https://control-panel-beta.dataships.eu",
    coreApiHost: "https://core-api-beta.dataships.eu",
    adminPanelHost: "https://admin-beta.dataships.eu",
    gtmId: "GTM-TGPTPKZ",
    flagsmithId: "Hy3fX5HrL9gXMdqqrKeBxX",
    flagsmithHost: "https://edge.api.flagsmith.com/api/v1/",
    shopifyAppInstallUrl:
      "https://partners.shopify.com/2404667/apps/13700890625/overview",
    complyPDFPolicyUrl: "images.dataships.eu",
    hubsportPortalId: "8868359",
    hubsportFormId: "04b6b5d9-8254-4aa4-93ac-7ebf2f3ba137",
    env: "staging",
  },
  development: {
    website: "https://wordpress.datashipslocal.com",
    webHost: "https://web-app.datashipslocal.com",
    controlPanelHost: "https://control-panel.datashipslocal.com",
    coreApiHost: "https://core-api.datashipslocal.com",
    adminPanelHost: "https://admin.datashipslocal.com",
    gtmId: "GTM-NFKNN67",
    flagsmithId: "hRyXbduWiSQ2aRYHhVp2nR",
    flagsmithHost: "https://edge.api.flagsmith.com/api/v1/",
    shopifyAppInstallUrl:
      "https://partners.shopify.com/2404667/apps/13855260673/overview",
    complyPDFPolicyUrl: "images.datashipslocal.com",
    hubsportPortalId: "8868359",
    hubsportFormId: "04b6b5d9-8254-4aa4-93ac-7ebf2f3ba137",
    env: "development",
  },
};

export const appEnvironments: IAppEnvironmentMap = {
  "web-app.dataships.io": "production",
  "web-app-beta.dataships.io": "production_beta",
  "web-app.dataships.eu": "staging",
  "web-app-beta.dataships.eu": "staging_beta",
  "web-app.datashipslocal.com": "development",
};
